export default function () {
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const title = `<h2>${slide.Title.slice(0, 50)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const buttons = function (btn1) {
      if (btn1) {
        const btnContainer = $(`<div class="button-container"></div>`);
        if (btn1) {
          btnContainer.append(
            `<a href="${btn1}" class="button ticket">
              <svg version="1.1" id="ticket-bg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                y="0px" viewBox="0 0 188.9 74.32" style="enable-background:new 0 0 188.9 74.32;" xml:space="preserve">
                <path class="st1" d="M176.87,61.86c0-1.97,4-3.58,8.94-3.58v-9c-4.94,0-8.94-1.6-8.94-3.58c0-1.97,4-3.58,8.94-3.58v-9
              c-4.94,0-8.94-1.6-8.94-3.58c0-1.97,4-3.58,8.94-3.58v-9c-4.94,0-8.94-1.6-8.94-3.58s4-3.58,8.94-3.58V2.68H2.26v7.16
              c4.66,0.12,8.34,1.67,8.34,3.56s-3.69,3.44-8.34,3.56v9.02c4.66,0.12,8.34,1.67,8.34,3.56c0,1.89-3.69,3.44-8.34,3.56v9.02
              c4.66,0.12,8.34,1.67,8.34,3.56c0,1.89-3.69,3.44-8.34,3.56v9.02c4.66,0.12,8.34,1.67,8.34,3.56s-3.69,3.44-8.34,3.56v6.38h183.55
              v-6.37C180.87,65.43,176.87,63.83,176.87,61.86z" />
              </svg>
              <span>Buy Tix</span>
              <svg version="1.1" id="ticket-arrow" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38.32 48"
              style="enable-background:new 0 0 38.32 48;" xml:space="preserve">
              <path class="st0" d="M6.42,1.51C7.15,1.65,8.22,2.54,9,3.12c8.27,6.15,16.56,12.28,24.79,18.49c3.6,2.72,3.54,4.77-0.19,7.28
                              c-8.41,5.66-16.89,11.22-25.3,16.88c-1.76,1.18-3.08,1.03-4.12-0.82c-0.65-1.16-1.22-2.36-1.81-3.55c-1.75-3.55-1.76-3.59,1.38-6.14
                              c3.35-2.73,6.66-5.52,10.13-8.1c1.97-1.47,2.1-2.57,0.27-4.27c-3.53-3.28-6.9-6.74-10.34-10.11C0.89,9.9,0.88,9.9,2.78,6.05
                              c0.59-1.19,1.18-2.38,1.93-3.46C5.04,2.11,5.69,1.37,6.42,1.51z" />
              </svg>

            </a>`
          );
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
    <div class="swiper-slide">
    <div role="region" class="swiper-image-container swiper-lazy" data-background="${
      slide.ImageWithPath
    }" aria-label="${slide.ImageAlternateText}">
      <div class="swiper-lazy-preloader"></div>
    </div>
    <div class="swiper-content-container">
      <div class="container">
        <div class="swiper-arrows__button swiper-arrows__button--prev" tabindex="0" role="button"
          aria-label="Previous slide">
          <span>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 38.32 48" style="enable-background:new 0 0 38.32 48;" xml:space="preserve">
            <path class="st0" d="M31.22,46.51c-0.73-0.14-1.8-1.03-2.58-1.61C20.37,38.75,12.08,32.62,3.86,26.4c-3.6-2.72-3.54-4.77,0.19-7.28
                            c8.41-5.66,16.89-11.22,25.3-16.88c1.76-1.18,3.08-1.03,4.12,0.82c0.65,1.16,1.22,2.36,1.81,3.55c1.75,3.55,1.76,3.59-1.38,6.14
                            c-3.35,2.73-6.66,5.52-10.13,8.1c-1.97,1.47-2.1,2.57-0.27,4.27c3.53,3.28,6.9,6.74,10.34,10.11c2.92,2.87,2.94,2.87,1.04,6.71
                            c-0.59,1.19-1.18,2.38-1.93,3.46C32.6,45.91,31.95,46.65,31.22,46.51z" />
          </svg>
          </span>
        </div>
        <div class="swiper-text"> 
          ${title}
          ${description}
        </div>
        ${buttons(slide.PurchaseURL)}
        <div class="swiper-arrows__button swiper-arrows__button--next" tabindex="0" role="button"
          aria-label="Next slide">
          <span>
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38.32 48"
              style="enable-background:new 0 0 38.32 48;" xml:space="preserve">
              <path class="st0" d="M6.42,1.51C7.15,1.65,8.22,2.54,9,3.12c8.27,6.15,16.56,12.28,24.79,18.49c3.6,2.72,3.54,4.77-0.19,7.28
                              c-8.41,5.66-16.89,11.22-25.3,16.88c-1.76,1.18-3.08,1.03-4.12-0.82c-0.65-1.16-1.22-2.36-1.81-3.55c-1.75-3.55-1.76-3.59,1.38-6.14
                              c3.35-2.73,6.66-5.52,10.13-8.1c1.97-1.47,2.1-2.57,0.27-4.27c-3.53-3.28-6.9-6.74-10.34-10.11C0.89,9.9,0.88,9.9,2.78,6.05
                              c0.59-1.19,1.18-2.38,1.93-3.46C5.04,2.11,5.69,1.37,6.42,1.51z" />
            </svg>
          </span>
        </div>

      </div>
    </div>
    <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
  </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach((slide, i) => {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    let autoplay = {
      delay: 6000,
    };

    let enableNav = {
      allowSlideNext: true,
    };

    function autoPlayCondition() {
      if (widgetData.length > 1) {
        return autoplay;
        return enableNav;
      } else {
        // class should be created. this can apply also for pagination
        return (autoplay = false);
        return (enableNav = false);
      }
    }

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        nextEl: '.swiper-arrows__button--next',
        prevEl: '.swiper-arrows__button--prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      a11y: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoPlayCondition(),
      allowSlideNext: autoPlayCondition(),
      allowSlidePrev: autoPlayCondition(),
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
